export default __webpack_public_path__ + "static/media/npc_02.128762a8.png";